// Only real shared constants.
export const ACCESSIBILITY_CONSTANTS = { LIVE_REGION_ID: 'live-region' };
